import { useState } from "react"
import Button from "@/components/core/Button/Button"
import Modal from "@/components/core/Modal/Modal"
import { useTranslation } from "next-i18next"
import styles from "./break-bundle.module.scss"

const BreakBundle = ({ showModal, setShowModal, onConfirm }) => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation("cart")

  const handleConfirm = () => {
    setLoading(true)
    onConfirm().finally(() => {
      setLoading(false)
      setShowModal(false)
    })
  }

  return (
    <div className={styles.breakBundle}>
      <Modal
        showModal={showModal}
        onModalClose={() => setShowModal(false)}
        hideCloseIcon={loading}
      >
        <div className="bundle-modal">
          <div className="bundle-modal__title">
            {t("kf.bundle.warningTitle")}
          </div>
          <p className="bundle-modal__desc">{t("kf.bindle.warningMessage")}</p>
          <div className="bundle-modal__cta">
            <Button
              customClass="bundle-modal__button"
              label="Yes"
              flexible
              type="black"
              onClick={handleConfirm}
              loading={loading}
              role="button"
            />
            <Button
              customClass="bundle-modal__button"
              label="No"
              flexible
              type="ghost"
              onClick={() => setShowModal(false)}
              disabled={loading}
              role="button"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default BreakBundle
